import {Component} from '@angular/core';
import {
    IonicPage, NavController, NavParams, ViewController, Platform, ToastController,
    LoadingController, AlertController
} from 'ionic-angular';
import {Storage} from '@ionic/storage';
import {ServiceProvider} from "../../providers/service/service";

@Component({
    selector: 'page-add-justdial-data',
    templateUrl: 'add-justdial-data.html',
})
export class AddJustdialDataPage {

    FUserId: any;
    Name: any;
    Mobile: any;
    School: any;
    SchoolData: any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public viewCtrl: ViewController,
                public platform: Platform,
                public storage: Storage,
                public toastCtrl: ToastController,
                public alertCtrl:AlertController,
                public loadingCtrl: LoadingController,
                public service: ServiceProvider) {
        this.platform.ready().then(() => {
            Promise.all([this.storage.get('LoginData')]).then(values => {
                this.FUserId = values[0]['FUserId'];
                console.log(this.FUserId);
                this.loadSchool();

            });
        });
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad AddJustdialDataPage');
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }


    loadSchool() {
        this.service.httpcall('web_service/get_school?').subscribe(data => {
            console.log(data);
            this.SchoolData = data['data'];
        })
    }

    submit_form() {
        if (this.Name == null || this.Name == "") {
            this.presentToast("Name Required!");
        } else if (this.Mobile == null || this.Mobile == "") {
            this.presentToast("Mobile Required!");
        } else if (this.Mobile.toString().length > 10 || this.Mobile.toString().length < 10) {
            this.presentToast("Mobile number must 10 digit Required!");
        } else if (this.School == null || this.School == "") {
            this.presentToast("School Required!");
        } else {
            var json_obj = {};
            json_obj['CreatedBy'] = this.FUserId;
            json_obj['Name'] = this.Name;
            json_obj['Phone'] = this.Mobile;
            json_obj['SchoolId'] = this.School;
            json_obj['IsJustDialData'] = 1;
            let url = 'web_service/add_JustDial_data_in_guest_user';

            console.log(json_obj);

            let loading = this.loadingCtrl.create({
                content: 'loading'
            });

            loading.present();


            this.service.httppostcall(url, json_obj).subscribe(data => {
                console.log(data);
                if (loading)
                    loading.dismiss();
                loading = undefined;
                if (data['response'] == 'success') {
                    //  this.presentToast(data['success_message']);
                    this.Name = null;
                    this.Mobile = null;
                    this.Mobile = null;
                    this.School = null;
                    this.viewCtrl.dismiss(data['success_message']);
                } else {
                    // this.presentToast(data['error_description']);
                    const alert = this.alertCtrl.create({
                        title: 'Error!',
                        subTitle: data['error_description'],
                        buttons: ['OK']
                    });
                    alert.present();
                }
            }, (err) => {
                loading.dismiss();
                console.log(json_obj);
                this.presentToast("TimeOut!");
            });
        }
    }

    presentToast(msg) {
        let toast = this.toastCtrl.create({
            message: msg,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/add-justdial-data/add-justdial-data.ts